import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux-auto'
import {connect} from 'react-redux'
import QuestionDoneMarker from '#components/m/Ausbildungsplan/QuestionDoneMarker'

export function withAnswer(QuestionComponent) {
  class WithAnswer extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        currentAnswer: props.currentAnswer || undefined,
        done: props.done,
      }
    }

    async componentDidUpdate(prevProps) {
      const {currentAnswer, postAnswer, nextQueueItem, isSaving} = this.props
      if (prevProps.currentAnswer !== currentAnswer) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({currentAnswer})
      }
      if (prevProps.isSaving === true && isSaving === false && nextQueueItem !== null) {
        await postAnswer(nextQueueItem)
      }
    }

    updateAnswer = answer => {
      this.setState({currentAnswer: answer})
    }

    handleToggle = () => {
      this.setState(
        prevState => ({
          done: !prevState.done,
        }),
        () => this.saveAnswer(),
      )
    }

    saveAnswer = async explicitAnswer => {
      const {postAnswer, enqueueAnswerPost, chapterId, question, isSaving} = this.props
      const {done} = this.state

      const answer = explicitAnswer || this.state.currentAnswer || {}
      const savePostParam = {
        chapterId,
        questionId: question.id,
        answer,
        done,
        antwortTyp: question.questionType,
      }
      if (answer) {
        if (isSaving) {
          enqueueAnswerPost(savePostParam)
        } else {
          await postAnswer(savePostParam)
        }
      }
    }

    render() {
      const {currentAnswer} = this.state
      return (
        <QuestionComponent
          {...this.props}
          updateAnswer={this.updateAnswer}
          currentAnswer={currentAnswer}
          saveAnswer={this.saveAnswer}
          error={this.props.error}
        >
          {!this.props.isReadOnly && (
            <QuestionDoneMarker
              checked={this.state.done}
              handleChange={this.handleToggle}
              questionId={this.props.questionId}
            />
          )}
        </QuestionComponent>
      )
    }
  }

  WithAnswer.displayName = `WithAnswer(${getDisplayName(QuestionComponent)})`

  WithAnswer.propTypes = {
    currentAnswer: PropTypes.object,
    isSaving: PropTypes.bool,
    postAnswer: PropTypes.func.isRequired,
    enqueueAnswerPost: PropTypes.func.isRequired,
    nextQueueItem: PropTypes.object,
    chapterId: PropTypes.string.isRequired,
    questionId: PropTypes.string,
    question: PropTypes.object,
    error: PropTypes.string,
    done: PropTypes.bool,
    isReadOnly: PropTypes.bool,
  }

  function mapStateToProps(state, props) {
    const getAnswer = () => {
      const {answers} = state.ausbildungsplan
      if (!answers) {
        return undefined
      }
      if (answers[props.chapterId]) {
        if (answers[props.chapterId][props.question.id]) {
          return answers[props.chapterId][props.question.id].antwort
        }
        return undefined
      }
      return undefined
    }
    const getDone = () => {
      const {answers} = state.ausbildungsplan
      if (!answers) {
        return false
      }
      if (answers[props.chapterId]) {
        if (answers[props.chapterId][props.question.id]) {
          return answers[props.chapterId][props.question.id].done
        }
        return false
      }
      return false
    }
    return {
      currentAnswer: getAnswer(),
      error: state.ausbildungsplan.error,
      isSaving: state.ausbildungsplan.isSaving,
      nextQueueItem: state.ausbildungsplan.queue[0] || null,
      done: getDone(),
    }
  }

  function mapDispatchToProps() {
    return {
      postAnswer: payload => actions.ausbildungsplan.postAnswer(payload),
      enqueueAnswerPost: payload => actions.ausbildungsplan.enqueueAnswerPost(payload),
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithAnswer)
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}
